import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import CustomFormsService from 'cio/services/custom-forms';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import IntegrationsFormsGeneralIndexController from './controller';
import RouterService from '@ember/routing/router-service';
import DS from 'ember-data';

export default class IntegrationsFormsGeneralIndex extends Route {
  @service auth!: AuthService;
  @service customForms!: CustomFormsService;
  @service facebookLeadAds!: FacebookLeadAdsService;
  @service router!: RouterService;
  @service store!: DS.Store;

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    if (!this.auth.hasPermission('journeys/imports/view')) {
      return this.router.transitionTo('setup-guide');
    }

    return;
  }

  async setupController(controller: IntegrationsFormsGeneralIndexController, model: unknown, transition: Transition) {
    super.setupController(controller, model as any, transition);

    controller.set('formCampaigns', this.store.peekAll('campaign').filterBy('isFormTriggered'));

    if (this.router.isActive('integrations.forms')) {
      await controller.initializeServicesTask.perform();
    }
    // must be called in "setupController()" instead of "activate()" hook to be able to access query params:
    controller.trackListViewedOrFiltered();
  }
}
